import type { HelpMessage } from './types';

export const HELP_CONTACT_EMAIL: string = import.meta.env.VITE_HELP_CONTACT_EMAIL ?? '';

export interface HelpMailtoOptions {
  email: string;
  contextLabel: string;
  messages: HelpMessage[];
  quoteCount?: number;
}

/** Markdown emphasis and headings read badly in a mail body; strip the marks, keep the words. */
function plainText(markdown: string): string {
  return markdown
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/(^|\s)[*_](.+?)[*_](?=\s|$)/g, '$1$2')
    .replace(/^#+\s*/gm, '')
    .replace(/\[(.+?)\]\(.+?\)/g, '$1');
}

/** Subject `DVA help: <context>`, body quoting the last few turns. Help content only, never portfolio data. */
export function buildHelpMailto({ email, contextLabel, messages, quoteCount = 4 }: HelpMailtoOptions): string {
  const transcript = messages
    .filter((message) => message.role !== 'system')
    .slice(-quoteCount)
    .map((message) => `${message.role === 'user' ? 'Me' : 'Ask DVA'}: ${plainText(message.text)}`)
    .join('\n\n');

  const body = transcript ? `\n\n---\nFrom the Ask DVA conversation:\n\n${transcript}` : '';
  const subject = encodeURIComponent(`DVA help: ${contextLabel}`);
  return `mailto:${email}?subject=${subject}&body=${encodeURIComponent(body)}`;
}
